<template>
  <div style="overflow: hidden; padding-top: 100px; padding-bottom: 250px" >

    <b-row class="m-0 justify-content-center" v-if="company">
      <div style="width: 1700px; max-width: 90%">
        
          <div class="image-preview py-3" v-if="company.img">
            <img class="preview rounded" alt="new" style="max-height: 100px" :src="getImage(company.img.image)">
          </div>


        <b-row class="m-0 justify-content-center" ref="settings">
          <div  class="showcase-invert bg-white shadow w-100 my-3">
          <div class="showcase-header py-4 linear-warning text-dark" style="position: relative">
            <h4 class="text-center m-0">Einstellungen</h4>
          </div>
            <b-row class="m-5 justify-content-center">
              <b-col cols="12" lg="6">
                <b-form-group
                style="font-size: 20px"
                label="Zahlungsmethoden:"
                >
                  <b-form-checkbox
                    switch size="lg"
                    @change="updateCompanyDelayed"
                    v-model="company.payment_methods.cash"
                    name="payment_method"
                  >
                    <font-awesome-icon icon="money-bill-wave" /> Bar
                  </b-form-checkbox>
                  <b-form-checkbox
                    switch size="lg"
                    @change="updateCompanyDelayed"
                    v-model="company.payment_methods.card"
                    name="payment_method"
                  >
                  <font-awesome-icon icon="credit-card" /> EC Karte
                  </b-form-checkbox>

                  <b-form-checkbox
                    switch size="lg"
                    @change="updateCompanyDelayed"
                    v-model="company.payment_methods.paypal"
                    name="payment_method"
                  >
                    <font-awesome-icon :icon="['fab', 'cc-paypal']"/> PayPal
                  </b-form-checkbox>

                  <b-form-checkbox
                    switch size="lg"
                    @change="updateCompanyDelayed"
                    v-model="company.payment_methods.credit_card"
                    name="payment_method"
                  >
                  <font-awesome-icon :icon="['fab', 'cc-visa']"/> Kreditkarte
                  </b-form-checkbox>

                  <b-button style="max-width: 200px" :disabled="soundCheck" block class="dropshadow my-4" variant="warning" @click="checkSound"> {{soundCheck ? 'wird abgespielt' : ' Bestellton testen'}} <font-awesome-icon v-if="soundCheck" :icon="['fas', 'volume-up']"/> </b-button>

                  <div v-if="$route.query.mobilenumber && !company.contact.mobile" class="mt-4" :class="$route.query.mobilenumber ? 'p-2 rounded pulse' : ''">
                    <b-form-group label="Mobilnummer:" description="An diese Telefonnummer werden Bestellungen und Informationen per SMS gesendet.">
                      <b-form-input
                        :state="!company.contact.mobile ? false : true"
                        v-model="company.contact.mobile"
                        type="text"
                        placeholder="Mobilnummer eingeben..."
                        required
                      ></b-form-input>
                    </b-form-group>
                    <b-button :disabled="updating" block class="dropshadow" variant="warning" @click="updateCompany()">speichern <b-spinner v-if="updating" small label="Spinning"></b-spinner></b-button>
                  </div>

                </b-form-group>
              </b-col>
              <b-col cols="12" lg="6">
                <h5 class="m-0 mb-2">Restaurant Listen</h5>
                <div v-if="menus">
                  <span v-if="menus.filter(menu => menu.active).length == 0" class="text-danger">Es muss mindestens eine Speise aktiv sein um das Restaurant zu listen! <span class="text-info hover" @click="$router.push('/menu')"> => zur Speisekarte</span></span>
                </div>
                <b-form-group
                :class="($route.query.goonline && !company.active) || ($route.query.gooffline && company.active)? 'p-2 rounded pulse' : ''"
                style="font-size: 20px"
                description="Sie können Ihr Restaurant deaktivieren. So werden sie, solange diese Einstellung aktiv ist, nicht in der App gelistet"
                v-if="menus"
                >
                  <b-form-checkbox
                    switch size="lg"
                    @change="updateCompanyDelayed"
                    v-model="company.active"
                    name="payment_method"
                    :disabled="!company.active && menus.filter(menu => menu.active).length == 0"
                  >
                    <font-awesome-icon icon="mobile" /> Restaurant in App {{ company.active ? 'gelistet' : 'nicht gelistet' }}
                  </b-form-checkbox>
                 
                </b-form-group>
                <b-form-group
                style="font-size: 20px"
                label="Lieferung:"
                description="Wählen sie diese Option, wenn Sie Ihre Speisen auch ausliefern."
                >
                  <b-form-checkbox
                    switch size="lg"
                    v-model="company.delivery"
                    name="payment_method"
                    @change="updateCompanyDelayed"
                  >
                    <font-awesome-icon icon="paper-plane" /> Lieferung {{ company.delivery ? 'möglich' : 'nicht möglich' }} 
                  </b-form-checkbox>
                 
                </b-form-group>

                <h5 class="m-0 mb-2">Bestellung per App <font-awesome-icon style="z-index: 2000" @click="infoModal = true" class="ml-1 p-0 m-0 h5 hover text-info" :icon="['fas', 'info-circle']"/></h5>
                <b-form-group
                style="font-size: 20px"
                description="Wählen sie diese Option, wenn Sie eine Online-Bestellung ermöglichen möchten, andernfalls können Kunden nur per Telefon bestellen."
                >
                  <b-form-checkbox
                    switch size="lg"
                    @change="updateCompanyDelayed"
                    v-model="company.enable_online_order"
                    name="payment_method"
                  >
                    <font-awesome-icon icon="mobile" /> Bestellung per App {{ company.enable_online_order ? 'aktiv' : 'nicht aktiv' }} 
                  </b-form-checkbox>
                 
                </b-form-group>
              </b-col>
            </b-row>
            
<!-- 
              <b-button v-if="!updating" block class="dropshadow mt-5" variant="warning" @click="updateCompany()">speichern</b-button>
              <b-button v-if="updating" block class="dropshadow mt-5" variant="warning"><b-spinner small label="Spinning"></b-spinner></b-button> -->
          </div>
        </b-row>
        <b-row class="m-0 justify-content-center" ref="opening_times">
          <div  class="showcase-invert bg-white shadow w-100 my-3">
            <div class="showcase-header py-4 linear-warning text-dark" :class="$route.query.opening_times ? 'pulse' : ''" style="position: relative">
              <h4 class="text-center m-0" >Einstellungen für Abholung</h4>
            </div>
            <h4 class="text-left m-0 ml-3 mt-3" >Abholzeiten:</h4>
            <b-row class="m-0 mt-4 justify-content-start" >
              <b-col cols="2">
                <div>
                  <h5 style="margin-bottom: 12px">Mo:</h5>
                  <h5 style="margin-bottom: 12px">Di:</h5>
                  <h5 style="margin-bottom: 12px">Mi:</h5>
                  <h5 style="margin-bottom: 12px">Do:</h5>
                  <h5 style="margin-bottom: 12px">Fr:</h5>
                  <h5 style="margin-bottom: 12px">Sa:</h5>
                  <h5 style="margin-bottom: 12px">So:</h5>
                </div>
              </b-col>
              <b-col cols="10" lg="4">
                <div>
                  <b-row v-for="day1 in company.opening_times" :key="day1.index" class="m-0">
                    <font-awesome-icon @click="day1.start_1 = null, day1.end_1 = null" class="hover h4 mt-1 mr-2 text-danger" :icon="['fa', 'times']"/> 
                    <b-input size="sm" type="time" style="max-width: 90px" v-model="day1.start_1"></b-input> 
                    <h4 class="mx-1">-</h4>
                    <b-input size="sm" type="time" style="max-width: 90px" v-model="day1.end_1"></b-input>
                    <h5 class="ml-1">Uhr</h5>
                  </b-row>
                </div>
              </b-col>
              <b-col cols="2" class="d-flex d-lg-none">
                <div class="mt-5 mt-lg-0">
                  <h5 style="margin-bottom: 12px">Mo:</h5>
                  <h5 style="margin-bottom: 12px">Di:</h5>
                  <h5 style="margin-bottom: 12px">Mi:</h5>
                  <h5 style="margin-bottom: 12px">Do:</h5>
                  <h5 style="margin-bottom: 12px">Fr:</h5>
                  <h5 style="margin-bottom: 12px">Sa:</h5>
                  <h5 style="margin-bottom: 12px">So:</h5>
                </div>
              </b-col>
              <b-col cols="10" lg="4">
                <div class="mt-5 mt-lg-0">
                  <b-row v-for="day2 in company.opening_times" :key="day2.index" class="m-0">
                    <font-awesome-icon @click="day2.start_2 = null, day2.end_2 = null" class="hover h4 mt-1 mr-2 text-danger" :icon="['fa', 'times']"/> 
                    <b-input size="sm" type="time" style="max-width: 90px" v-model="day2.start_2"></b-input> 
                    <h4 class="mx-1">-</h4>
                    <b-input size="sm" type="time" style="max-width: 90px" v-model="day2.end_2"></b-input>
                    <h5 class="ml-1">Uhr</h5>
                  </b-row>                
                </div>
              </b-col>
            </b-row>
            <b-col cols="12">

              <b-form-group class="mt-4" label="Anzahl Slots pro 15 Minuten:" description="Ihre Möglichen Bestellungen werden in 15 Minuten Schritte aufgeteilt, so genannte 'Slots'. Sie können selbst entscheiden, wieviele Bestellungen Sie pro 15 Minuten akzeptieren möchten.">
                <b-form-input
                  v-model="company.amount_slots"
                  type="number"
                  step="1"
                  placeholder="Anzahl eingeben..."
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12">

              <b-form-group class="mt-4" label="Vorlaufzeit in Minuten" description="Zeitabstand zur nächstmöglichen Bestellung">
                <b-form-input
                  v-model="company.pre_time"
                  type="number"
                  step="1"
                  placeholder="Zeit in Minuten  eingeben..."
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
              <b-button v-if="!updating" block class="dropshadow mt-5" variant="warning" @click="updateCompany()">speichern</b-button>
              <b-button v-if="updating" block class="dropshadow mt-5" variant="warning"><b-spinner small label="Spinning"></b-spinner></b-button>
          </div>
        </b-row>

        <b-row class="m-0 justify-content-center" v-if="company.delivery" ref="delivery_times">
          <div  class="showcase-invert bg-white shadow w-100 my-3">
            <div class="showcase-header py-4 linear-warning text-dark" :class="$route.query.delivery_times ? 'pulse' : ''" style="position: relative">
              <h4 class="text-center m-0">Einstellungen für Lieferung</h4>
            </div>
            <h4 class="text-left m-0 ml-3 mt-3" >Lieferzeiten:</h4>
            <b-row class="m-0 mt-4 justify-content-start" >
              <b-col cols="2">
                <div>
                  <h5 style="margin-bottom: 12px">Mo:</h5>
                  <h5 style="margin-bottom: 12px">Di:</h5>
                  <h5 style="margin-bottom: 12px">Mi:</h5>
                  <h5 style="margin-bottom: 12px">Do:</h5>
                  <h5 style="margin-bottom: 12px">Fr:</h5>
                  <h5 style="margin-bottom: 12px">Sa:</h5>
                  <h5 style="margin-bottom: 12px">So:</h5>
                </div>
              </b-col>
              <b-col cols="10" lg="4">
                <div>
                  <b-row v-for="day1 in company.delivery_times" :key="day1.index" class="m-0">
                    <font-awesome-icon @click="day1.start_1 = null, day1.end_1 = null" class="hover h4 mt-1 mr-2 text-danger" :icon="['fa', 'times']"/> 
                    <b-input size="sm" type="time" style="max-width: 90px" v-model="day1.start_1"></b-input> 
                    <h4 class="mx-1">-</h4>
                    <b-input size="sm" type="time" style="max-width: 90px" v-model="day1.end_1"></b-input>
                    <h5 class="ml-1">Uhr</h5>
                  </b-row>
                </div>
              </b-col>
              <b-col cols="2" class="d-flex d-lg-none">
                <div class="mt-5 mt-lg-0">
                  <h5 style="margin-bottom: 12px">Mo:</h5>
                  <h5 style="margin-bottom: 12px">Di:</h5>
                  <h5 style="margin-bottom: 12px">Mi:</h5>
                  <h5 style="margin-bottom: 12px">Do:</h5>
                  <h5 style="margin-bottom: 12px">Fr:</h5>
                  <h5 style="margin-bottom: 12px">Sa:</h5>
                  <h5 style="margin-bottom: 12px">So:</h5>
                </div>
              </b-col>
              <b-col cols="10" lg="4">
                <div class="mt-5 mt-lg-0">
                  <b-row v-for="day2 in company.delivery_times" :key="day2.index" class="m-0">
                    <font-awesome-icon @click="day2.start_2 = null, day2.end_2 = null" class="hover h4 mt-1 mr-2 text-danger" :icon="['fa', 'times']"/> 
                    <b-input size="sm" type="time" style="max-width: 90px" v-model="day2.start_2"></b-input> 
                    <h4 class="mx-1">-</h4>
                    <b-input size="sm" type="time" style="max-width: 90px" v-model="day2.end_2"></b-input>
                    <h5 class="ml-1">Uhr</h5>
                  </b-row>                
                </div>
              </b-col>
              <b-col cols="12">

              <b-form-group class="mt-4" label="Aktuelle Lieferzeit in Minuten" description="Aktuell ca. benötigte Zeit zum Ausliefern der Bestellung">
                <b-form-input
                  v-model="company.actual_delivery_time"
                  type="number"
                  @change="debounceInput()"
                  step="1"
                  placeholder="Zeit in Minuten eingeben..."
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group class="mt-4" label="Maximale Lieferentfernung (in Km)">
                <b-form-input
                  v-model="company.maximum_delivery_radius"
                  type="number"
                  @change="debounceInput()"
                  step="1"
                  placeholder="Radius in Km eingeben..."
                  required
                ></b-form-input>
              </b-form-group>

              <h5 class="mt-5">Mindestbestellwerte:</h5>

              <b-row class="m-0">
              <div :class="index == 0 ? 'mr-3' : 'mx-3'" v-for="(minimum_order_value, index) in company.minimum_order_value" :key="minimum_order_value.index">
                <hr>
                <p class="m-0 mb-2">Staffellung {{ index + 1 }}:</p>
                <b-form-group label="Lieferradius (in Km):">
                  <b-form-input
                    v-model="minimum_order_value.range"
                    @change="debounceInput()"
                    type="number"
                    size="sm"
                    step="0.1"
                    placeholder="Radius in Km eingeben..."
                    required
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Mindestbestellwert:">
                  <b-form-input
                    v-model="minimum_order_value.value"
                    type="number"
                    @change="debounceInput()"
                    size="sm"
                    step="0.1"
                    placeholder="Mindestbestellwert in € eingeben..."
                    required
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Lieferkosten:">
                  <b-form-input
                    v-model="minimum_order_value.delivery_fee"
                    type="number"
                    @change="debounceInput()"
                    size="sm"
                    step="0.1"
                    placeholder="Lieferkosten in € eingeben..."
                    required
                  ></b-form-input>
                </b-form-group>
                <b-button block size="sm" variant="danger" @click="company.minimum_order_value.splice(index, 1), updateCompany()">löschen</b-button>
              </div>

              </b-row>

              <hr>

              <h5>Neuen Mindestbestellwert-Radius eingeben</h5>
              
              <b-form-group class="mt-4" label="Lieferradius (in Km):">
                  <b-form-input
                    v-model="new_minimum_order_value.range"
                    type="number"
                    step="0.1"
                    placeholder="Radius in Km eingeben..."
                    required
                  ></b-form-input>
                </b-form-group>
                <b-form-group class="mt-4" label="Mindestbestellwert:">
                  <b-form-input
                    v-model="new_minimum_order_value.value"
                    type="number"
                    step="0.1"
                    placeholder="Mindestbestellwert in € eingeben..."
                    required
                  ></b-form-input>
                </b-form-group>

                <b-button :disabled="!new_minimum_order_value.range || !new_minimum_order_value.value" variant="success" @click="addMinimumOrderValue()">Mindestbestellwert hinzufügen</b-button>


            </b-col>
            </b-row>
              <b-button v-if="!updating" block class="dropshadow mt-5" variant="warning" @click="updateCompany()">speichern</b-button>
              <b-button v-if="updating" block class="dropshadow mt-5" variant="warning"><b-spinner small label="Spinning"></b-spinner></b-button>
          </div>
        </b-row>
        
        <b-row class="m-0 justify-content-center">
          <div  class="showcase-invert bg-white shadow w-100 my-3">
          <div class="showcase-header py-4 linear-warning text-dark" style="position: relative">
            <h4 class="text-center m-0">Vorschau App-Eintrag:</h4>
          </div>

          <b-form-group
            class="mx-1 my-4"
            label="Restaurantname in der Adresszeile:"
            :description="'https://eatdorado.de/my/' + (company.url ? company.url : 'mein-beispiel-restaurant') "
          >
            <b-form-input
              :state="urlFree"
              v-model="company.url"
              type="text"
              required
              placeholder="Wunschname eingeben"
            ></b-form-input>
            <b-form-invalid-feedback :state="urlFree">
              Name ist nicht verfügbar!
            </b-form-invalid-feedback>
            <b-form-valid-feedback :state="urlFree">
              Name ist verfügbar!
            </b-form-valid-feedback>
          </b-form-group>
          <div v-if="company">
            <restaurant-regular v-if="company.img" :city="company.adress.city" :distance="'0.0'" :street="company.adress.street" :name="company.title" :img="company.img.image" :description="company.description" ></restaurant-regular>
          </div>
          <b-button v-if="!updating" block :disabled="urlFree ? false: true" class="dropshadow mt-5" variant="warning" @click="updateCompany()">speichern</b-button>
              <b-button v-if="updating" block class="dropshadow mt-5" variant="warning"><b-spinner small label="Spinning"></b-spinner></b-button>
          </div>
        </b-row>

        <b-row class="m-0 justify-content-center">
          <div  class="showcase-invert bg-white shadow w-100 my-3">
          <div class="showcase-header py-4 linear-warning text-dark" style="position: relative">
            <h4 class="text-center m-0">Restaurantangaben</h4>
          </div>
          <init-wizard :init="false"></init-wizard>
          </div>
        </b-row>


        <b-row class="m-0 justify-content-center" v-show="false">
          <div  class="showcase-invert bg-white shadow w-100 my-3">
          <div class="showcase-header py-4 linear-warning text-dark" style="position: relative">
            <h4 class="text-center m-0">Account-Guthaben {{ company.balance ? company.balance.toFixed(2) : '0.00' }}€</h4>
          </div>
          <b-row class="m-0 justify-content-start">
            <b-col class="mt-3">
              <b-form-group
              label="Guthaben aufladen:"
                description="Mindestens 20€ - maximal 2000€">
                <b-input-group
                prepend="€"
                style="font-size: 20px"
                >

                 <b-form-input
                  min="20"
                  max="2000"
                  :state="product.price < 2 ? false : true"
                  v-model="product.price"
                  type="number"
                  step="0.01"
                  placeholder="Preis eingeben..."
                  required
                ></b-form-input>
              </b-input-group>
              </b-form-group>
              <b-row class="m-0 pt-4 justify-content-start" v-if="paidfor">
                <check-animation v-if="paidfor" class="mt-4 mr-2" style="transform: scale(.5)"></check-animation>
                <h4 class="ml-5 mt-2">Zahlung eingegangen!</h4>
              </b-row>
              
              
            </b-col>
            <b-col>
              <div ref="paypal"></div>
            </b-col>
           
          </b-row>
           
          </div>
        </b-row>

        <b-row class="m-0 justify-content-center">
          <div  class="showcase-invert bg-white shadow w-100 my-3">
          <div class="showcase-header py-4 linear-warning text-dark" style="position: relative">
            <h4 class="text-center m-0">QR-Code</h4>
          </div>
          <b-row class="m-0 justify-content-center my-5">
            <qrcode-vue class="hover"  :value="qrcode" :size="size" level="L" ></qrcode-vue>
          </b-row>
          <b-row class="m-0 justify-content-center mt-5">
            <p>Dieser QR-Code leitet direkt zu deinem Restaurant weiter, wenn er gescannt wird.</p>
          </b-row>
          <b-row class="m-0 justify-content-center mb-5">
            <p>Rechtsklick auf den QR-Code -> Bild speichern unter</p>
          </b-row>
          </div>
        </b-row>

      </div>
    </b-row>
    <b-modal id="infoModal" v-model="infoModal" hide-footer hide-header>
      <div class="bg-white" style="border-radius: 10px; transition: all .5s;">
        <b-row class="m-0 p-3 justify-content-between" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <h4 class="ml-2 text-center text-dark" >Bestellung per App</h4>
          <font-awesome-icon @click="infoModal = false" style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
        <div class="m-3">
          <p>Ermöglichen Sie Ihren Kunden eine Bestellung per App, werden Sie über neue Bestellungen per E-Mail oder hier über <a href="/orders">Bestellungen</a> informiert.</p>
          <p class="pb-4">Sie müssen eingegangene Bestellungen bestätigen und dem Kunden somit versichern, dass Sie die Bestellung zum angegebenen Zeitpunkt bereitstellen / liefern.</p>
        </div>
       
      </div>
    </b-modal>
  </div>
</template>

<script>
import coreData from '@/mixins/coreDataMixin'
import RestaurantRegular from '@/views/components/RestaurantRegular'
import InitWizard from '@/views/components/InitWizard'
import QrcodeVue from 'qrcode.vue'
import debounce from 'debounce'
// import CheckAnimation from '@/shared/animations/checkAnimation.vue'

export default {
  name: 'Einstellungen',
  mixins: [coreData],
  components: {
    RestaurantRegular,
    InitWizard,
    QrcodeVue,
    // CheckAnimation
  }, 
  data: () => {
    return {
      new_minimum_order_value: {},
      size: 300,
      soundCheck: false,
      infoModal: false,
      fields: [
        { key: 'date', label: 'Bestellzeit' },
        { key: 'deliveryTime', label: 'Abhol-/Lieferzeit' },
        { key: 'customer', label: 'Kunde' },
        { key: 'amount', label: 'Preis' },
        { key: 'paymentMethods', label: 'Zahlungsmethode' },
        { key: 'orderNumber', label: 'Bestellnummer' },
        { key: 'status', label: 'Status' },
        { key: 'action', label: 'Aktionen' },
      ],
      departmentForm: {},
      newDepartment: false,
      paidfor: false,
      loaded: false,
      product: {
        price: 20.00,
        description: "eatDorado Business Guthaben"
      }
    }
  },
  watch: {
    // company: {
    //   deep: true,
    //     handler(){
    //       if(this.authError){
    //         this.$store.commit('authError', null)
    //         this.$store.commit('authMessage', null)
    //       }
    //     }
        
    //   }
    'company.url': function() {
        this.company.url = this.removeSpecialChars(this.company.url)
        this.$store.dispatch('checkUrl', {name: this.company.url})
    } 
  },
  computed: {
    qrcode(){
      return 'https://eatdorado.de/my/'+this.company._id
    },
    week(){
      if(this.kw){
        return {year: this.kw[0], week: this.kw[1], month: this.kw[2]}
      }
      return null
    },
    urlFree(){
      return this.$store.getters.urlFree
    }
  },
  mounted(){
    this.$store.commit('urlFree', null)
    this.refreshData();
    // const script = document.createElement("script");
    // script.src =
    //   "https://www.paypal.com/sdk/js?client-id=ARbWWULZdlb5CVHTVHeHMGZgeY-pMkm2qKDLVzmGRL7v5GmjWvNGDhMDZgCKEfhb3EGAgZeDuLmKOSWf&currency=EUR";
    // script.addEventListener("load", this.setLoaded);
    // document.body.appendChild(script);
  },
  created(){

  },
  methods: {
    debounceInput: debounce(function () {
      this.updateCompany();
    }, 300),
    addMinimumOrderValue(){
      if(!this.company.minimum_order_value){
        this.company.minimum_order_value = [this.new_minimum_order_value]
      }else{
        this.company.minimum_order_value.push(this.new_minimum_order_value)
      }
      this.updateCompany();
    },
    removeSpecialChars(str) {
      return str
        // .replace(/(?!\w|\s)./g, '')
        .replace(/\s+/g, '')
        .toLowerCase()
        .replace(/^(\s*)([\W\w]*)(\b\s*$)/g, '$2');
    },
    setLoaded() {
      this.loaded = true;
      window.paypal
        .Buttons({
          createOrder: (data, actions) => {
            this.paidfor = false
            return actions.order.create({
              purchase_units: [
                {
                  description: this.product.description,
                  amount: {
                    currency_code: "EUR",
                    value: this.product.price
                  }
                }
              ]
            })

          },
          onApprove: async (data, actions) => {
            const order = await actions.order.capture();
            this.paidfor = true;
            var saveOrder = {
              created: new Date(),
              company: this.company._id,
              value: parseFloat(this.product.price),
              status: order.status,
              paypal_response: JSON.stringify(order)
            }
            this.$store.dispatch('addFunds', saveOrder)
          },
          onError: err => {
            console.log(err);
          }
        })
        .render(this.$refs.paypal);
    },
    checkSound(){
      if(!this.soundCheck){
        this.soundCheck = true
        this.playSound()
        var vm = this
        setTimeout(function() {
          vm.soundCheck = false
        }, 8000);
      }
    }
  },
  
}
</script>

<style lang="scss" scoped>


</style>